// Special Dates
export const getSpecialDates = async (welletContext, marketId, organizationId, { limit = 10, skip = 0, status = 'All', showIds = null } = {}) => {
  const url = organizationId
    ? `/api/specialdate/${marketId}/all/${organizationId}`
    : `/api/specialdate/${marketId}/all`;
  const body = { limit, skip, status };
  if (showIds) body.showIds = showIds;
  return await welletContext.apis.admin.post(url, body);
};

export const getSpecialDateById = async (welletContext, id) => {
  return await welletContext.apis.admin.get(`/api/specialdate/${id}`);
};

export const createSpecialDate = async (welletContext, body) => {
  return await welletContext.apis.admin.post(`/api/specialdate`, body);
};

export const updateSpecialDate = async (welletContext, body) => {
  return await welletContext.apis.admin.put(`/api/specialdate`, body);
};

export const deleteSpecialDate = async (welletContext, id) => {
  return await welletContext.apis.admin.delete(`/api/specialdate/${id}`);
};

export const unlinkSpecialDateProduct = async (welletContext, specialDateId, productId) => {
  return await welletContext.apis.admin.delete(`/api/specialdate/${specialDateId}/product/${productId}`);
};

export const getSpecialDateProducts = async (welletContext, showId, reservationType) => {
  return await welletContext.apis.admin.post(`/api/specialdate/products/${showId}`, {
    reservationType,
  });
};

export const getSpecialDatesByProduct = async (welletContext, productId) => {
  return await welletContext.apis.admin.get(`/api/specialdate/by-product/${productId}`);
};
